//import http from "./Http";
import axios from 'axios'

export default {

    reverse(lat, lon) {

        const http = axios.create({
            timeout: 10000,
            headers: {
              'Content-Type': 'application/json'
            }
          })

        var url = "http://self1.selftrack.co.za/geocode/do/" + lat + "/" + lon
            //"https://api.tomtom.com/search/2/search/" + lat+","+lon + ".json?key=7Gb9RdSTL1GBohBX4G5g5ne8XEBWuLH9"
        return http
          .get(url)
          .then(response => {
            return response.data.address
        })
        .catch(e => {
            throw e.message;
        });
      }


}